import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Modal } from 'antd';
import React from 'react';

const RemoveProductsModal = ({
  open,
  onClose,
  onConfirm,
  selectedProducts,
  loading = false,
}) => {
  const handleConfirm = () => {
    onConfirm();
  };

  return (
    <Modal
      title={
        <span>
          <ExclamationCircleOutlined
            style={{ color: '#faad14', marginRight: 8 }}
          />
          Confirmer le retrait
        </span>
      }
      open={open}
      onCancel={onClose}
      onOk={handleConfirm}
      okText="Confirmer"
      cancelText="Annuler"
      okButtonProps={{
        danger: true,
        loading: loading,
      }}
    >
      <p>
        Êtes-vous sûr de vouloir retirer{' '}
        <strong>{selectedProducts.length}</strong>{' '}
        {selectedProducts.length > 1 ? 'produits' : 'produit'} de cette
        catégorie marketplace ?
      </p>
      <p style={{ color: '#8c8c8c', fontSize: '12px' }}>
        Cette action supprimera l’association entre{' '}
        {selectedProducts.length > 1 ? 'ces produits' : 'ce produit'} et la
        catégorie.
      </p>
    </Modal>
  );
};

export default RemoveProductsModal;
